export default __webpack_public_path__ + "static/media/image1.3b5e07c1.jpg";